import React from 'react'
import PropTypes from 'prop-types'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

const AppBarAdapter = ({
  children, className, position,
}) => (
  <AppBar
    className={className}
    position={position}
  >
    <Toolbar>
      { children }
    </Toolbar>
  </AppBar>
)

AppBarAdapter.defaultProps = {
  position: 'fixed',
  className: '',
}

AppBarAdapter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  position: PropTypes.oneOf([
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky',
  ]),
}

export default AppBarAdapter
